import React from 'react';
import { Button, Stack } from '@mui/material';
import * as CommonFunctions from '../../services/CommonFunctions';

/**
 * Renderer dla kolumny "Oświadczenie".
 * Wyświetla przyciski Pobierz dla pliku oświadczenia.
 * Oświadczenie jest wgrywane w modalu sprawozdania, więc tu nie ma przycisku Wgraj.
 * Usuwanie odbywa się kaskadowo po usunięciu sprawozdania (zgodnie z wymaganiami brak przycisku Usuń).
 */
const DeclarationFileCellRenderer = ({
    data,
    uploadedDeclarations,
    token,
}) => {
    const rowId = data?.id ?? null;
    
    // Pobieramy dane pliku oświadczenia wyłącznie z DTO wiersza,
    // które jest zawsze aktualne dzięki applyTransaction. Używanie domknięcia uploadedDeclarations powodowało stale closure.
    const fileInfo = data?.declarationFileMetadataDTO || null;

    const onDownload = async () => {
        try {
            await CommonFunctions.downloadFile(
                fileInfo.id || fileInfo.fileId,
                fileInfo.fileType || 61,
                null, null, null,
                token
            );
        } catch (error) {
            console.error('Błąd podczas pobierania oświadczenia:', error);
        }
    };

    if (!fileInfo) return null;

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
            <Stack direction="row" spacing={1}>
                <Button
                    variant="outlined"
                    color="info"
                    size="small"
                    onClick={onDownload}
                >
                    Pobierz
                </Button>
            </Stack>
        </div>
    );
};

export default DeclarationFileCellRenderer;
